import { clsx } from 'clsx';
import type { MouseEvent, ReactNode } from 'react';

import styles from './imageActionButton.module.css';

interface ImageActionButtonProps {
  'aria-label': string;
  'aria-pressed': boolean;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick: () => void;
}

export const ImageActionButton = ({
  children,
  className,
  onClick,
  ...props
}: ImageActionButtonProps) => {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  return (
    <button
      type="button"
      className={clsx(styles['button'], className)}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
};
